// eslint-disable-next-line @stencil-community/ban-exported-const-enums
export enum ERightSideBarEnum {
    NONE = -1,
    NOTIFICATIONS = 0,
    SETTINGS = 1,
    AMEND_PENDING_ORDER = 2,
    DETAILS_VIEW = 3,
}
